export const environment = {
  URL_OMNI_MAIS_API:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/rodas/v1/api/',
  URL_OMNI_MAIS_API_V2:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/rodas/v2/api/',
  URL_OMNI_DOC_UPLOAD:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/doc-upload/api/',
  URL_OMNI_MAIS_VIABILIDADE:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/cob-viabilidade/api/',
  URL_OMNI_FACIL:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/login-omnifacil/api/',
  URL_OMNI_FACIL_SISTEMA:
    'https://hmg-omnicfi-ohs.hmg-omnicfi.us-east-1.omniaws.io/hml/',
  URL_OMNI_GERAL: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/geral/api/',
  URL_CDC_LOJA: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/cdcl/api/',
  URL_CREDITO_PESSOAL: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/cp/api/',
  URL_OMNI_VEHICLE_REPORT:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/auto-laudo/api/',
  URL_MICROCREDITO: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/cp-mc/api/',
  URL_OMNI_FINANCEIRO:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/financeiro/api/',
  URL_LEADS_ONLINE: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/leads/api/',
  URL_FINANCEIRO:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/financeiro/api/',
  URL_MESA_EFETIVE_MAIS:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/mesa-efetive-mais/api/',
  URL_RODAS: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/rodas/v2/api/',
  URL_CDC: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/cdc-estruturado/api',
  production: false,
  homologation: true,
  VERSION_APP: '2.4.0',
  SHOW_CP: true,
  ECOMMERCE_ENCRYPT_KEY: 'VkN6ZlpIaWNMbU1vQlpJQQ==',
  SIMULACAO_TENTATIVAS: 20,
  URL_OMNI_CDCL_API_GATEWAY:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/cdcl/api/',
  URL_RODAS_FICHA:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/rodas-ficha/api/',
  URL_RODAS_VEICULOS:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/veiculos/api/',
  URL_PARAMETROS_COBRANCA:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/agentes-digitais/parametros/api/v1/',
  URL_DIGITAL_AGENT:
    'https://api.dev-omnicfi.us-east-1.omniaws.io/agentes-digitais/parametros/api/v1/',
  URL_SEGUROS: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/seguro/api/',
  URL_OMNI_MAIS_PJ:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/rodas-pj/api/',
  URL_ASSINATURA:
    'https://api.hmg-omnicfi.us-east-1.omniaws.io/rodas-assinatura/api/',
  SIMULACAO_TEMPO: 7200,
  ITENS_PAGINA_HOME: '30, 50, 100',
  WHATSAPP_NUMBER: '551140043500',
  URL_APP_DOWNLOAD: 'https://omnil.page.link/bv_link_app',
  URL_OMNI_SEGURO: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/seguro/api/',
  URL_OMNI_ASSISTENCIA: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/assistencia/api/',
  URL_LOJISTA: 'https://api.hmg-omnicfi.us-east-1.omniaws.io/lojista/api/',
  URL_ERP: 'https://hmg-erp.omni.com.br',
  FIREBASE: {
    VAPID_KEY: 'BKeWOezJAu1DFAlAPL18BzQ8UKPcAUvg-NchnlyFEsrLP0uhFDPbGVpDj3SQeIVAJyAeekd7y4MDfQIWa7HgNf8',
    API_KEY: "AIzaSyDH2BP5OYS65CFk37kd_AFQz74GI7TxdKo",
    AUTH_DOMAIN: "omnifacil-auto.firebaseapp.com",
    DATABASE_URL: "https://omnifacil-auto.firebaseio.com",
    PROJECT_ID: "omnifacil-auto",
    STORAGE_BUCKET: "omnifacil-auto.appspot.com",
    MESSAGING_SENDER_ID: "129479194853",
    APP_ID: "1:129479194853:web:3d2fe4ce8b6eb66f353c0c",
    MEASUREMENT_ID: "G-HKY1JG6339"
  }
};

export const redirectUrlHomeCDC = 'app/omni-cdc-estruturado-mf/home';
export const redirectUrlSimulatorCDC = 'app/omni-cdc-estruturado-mf/simulator';
export const redirectUrlCDC = 'app/omni-cdc-estruturado-mf/home';

export const OMNI_MAIS_REDIRECT_BASE_URL= 'https://hmg-omni-mais.omni.com.br';
